(function (angular) {
    'use strict';

    /**
     * Controller for the <content-toggle> directive
     *
     * @returns {void}
     */
    function contentToggleDirectiveController($scope) {

        /**
         * Hides or shows the directive content
         *
         * @returns {void}
         */
        function toggle() {
            $scope.contentIsVisible = !$scope.contentIsVisible;
        }

        // params
        $scope.contentIsVisible = false;

        // methods
        $scope.toggle = toggle;
    }

    /**
     * Returns configuration for the <content-toggle> directive
     *
     * @returns {object} directive configuration
     */
    function contentToggleDirective() {
        return {
            restrict: 'E',
            templateUrl: 'directives/content-toggle.html',
            transclude: true,
            link: contentToggleDirectiveController,
            scope: {
                title: '@',
            },
        };
    }

    angular.module('app')
        .directive('contentToggle', contentToggleDirective);

}(angular));
